import { Component } from '@angular/core';

@Component({
    selector: 'contact',
    template: require('./contact.component.html'),
})

export class ContactComponent {    

    constructor() {
    
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/contact/contact.component.ts
 **/